import React, { useState, useEffect, useRef } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import logo_rodape from "../assets/imagens/logo_rodape.jpg";
import '../style/rodape.css';
import api from '../redux/actions/configApi';



const Rodape = () => {

    const [horarios, setHorarios] = useState([]);
    const [latitude, setLatitude] = useState();
    const [longitude, setLongitude] = useState();
    const [endereco, setEndereco] = useState([]);
    const [showModal, setShowModal] = useState(false); // Controle do modal
    const [mapVisible, setMapVisible] = useState(false); // Estado para controlar a visibilidade do mapa
    const mapRef = useRef(null); // Referência para o mapa

    const formatarHorarios = (weekdayText) => {

        const diasUteis = ['segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira'];
        let horarioDiasUteis = null;
        let horarioSabado = null;
        let horarioDomingo = null;

        weekdayText.forEach((horario) => {
            const [dia, horas] = horario?.split(': ');

            if (diasUteis.includes(dia)) {
                if (!horarioDiasUteis) {
                    horarioDiasUteis = horas;
                } else if (horarioDiasUteis !== horas) {
                    horarioDiasUteis = null; // Horários diferentes, não agrupar
                }
            } else if (dia === "sábado") {
                horarioSabado = horas;
            } else if (dia === "domingo") {
                horarioDomingo = horas;
            }
        });

        const resultado = [];
        if (horarioDiasUteis) {
            resultado.push(`Segunda a Sexta: ${horarioDiasUteis}`);
        } else {
            diasUteis.forEach((dia) => {
                const horas = weekdayText.find((horario) => horario.startsWith(dia))?.split(': ')[1];
                resultado.push(`${dia}: ${horas}`);
            });
        }

        if (horarioSabado) {
            resultado.push(`Sábado: ${horarioSabado}`);
        }

        if (horarioDomingo && horarioDomingo.toLowerCase() !== "closed") {
            resultado.push(`Domingo: ${horarioDomingo}`);
        } else {
            resultado.push("Domingo: Fechado");
        }

        return resultado;
    };
    useEffect(() => {
        const fetchGoogleReviews = async () => {
            try {
                const response = await api.get('googleMaps');
                setEndereco(response.data.vicinity)
                setLongitude(response.data.longitude);
                setLatitude(response.data.latitude);
                // Armazena o objeto no localStorage
                localStorage.setItem('endereco', JSON.stringify(response.data.vicinity));
                // Obter e formatar os horários
                const weekdayText = response?.data?.opening_hours || [];
                console.log(weekdayText, 'weekdayText');
                const horariosFormatados = formatarHorarios(weekdayText);
                setHorarios(horariosFormatados);
                localStorage.setItem('horarios', JSON.stringify(horariosFormatados));
            } catch (error) {
                console.error("Erro ao buscar informações do rodapé: ", error);
            }
        };

        fetchGoogleReviews();
    }, []);

    useEffect(() => {
        // Verifica se o mapa entrou na área visível da tela
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setMapVisible(true); // Quando o mapa estiver visível, carrega o iframe
            }
        }, { threshold: 0.5 });

        if (mapRef.current) {
            observer.observe(mapRef.current);
        }

        return () => {
            if (mapRef.current) {
                observer.unobserve(mapRef.current);
            }
        };
    }, []);


    return (
        <div className="site-footer py-4 mt-5" id="rodape">
            <Container>
                <Row>
                    {/* Coluna do Mapa de Localização */}
                    <Col md={8} className="mb-4 mb-md-0">
                        <p className="info-localizacao">
                            <i className="fas fa-map-marker-alt p-3"></i>
                            {endereco}
                        </p>
                        <div ref={mapRef}>
                            {mapVisible && (
                                <iframe
                                    title="mapa-localizacao"
                                    src={`https://www.google.com/maps?q=${latitude},${longitude}&output=embed`}
                                    width="100%"
                                    height="500"
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                ></iframe>
                            )}
                        </div>
                    </Col>

                    {/* Coluna com Informações e Redes Sociais */}
                    <Col md={4} className="shadow-lg p-3 mb-5 bg-white rounded">
                        <div className="box-rodape">
                            <h1>Horário de Funcionamento</h1>
                            <div className="borda-rodape"></div>
                            {horarios?.map((horario, index) => (
                                <p key={index}>{horario}</p>
                            ))}
                        </div>
                        <div className="box-rodape">
                            <h1>Redes Sociais</h1>
                            <div className="borda-rodape"></div>
                            <div className="d-flex">
                                <a href="https://www.facebook.com/@pentalobe" target="_blank" rel="noopener noreferrer" className="text-white mr-3">
                                    <i className="fab fa-facebook fa-2x"></i>
                                </a>
                                <a href="https://www.instagram.com/pentalobe?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" className="text-white mr-3">
                                    <i className="fab fa-instagram fa-2x"></i>
                                </a>
                                {/*<a href="#rodape" target="_blank" rel="noopener noreferrer" className="text-white">
                                <i class="fa-brands fa-x-twitter fa-2x"></i>
                                </a>*/}
                            </div>
                        </div>
                        <div className="box-rodape">
                            <h1>Políticas de Privacidade</h1>
                            <div className="borda-rodape"></div>
                            <div className="d-flex">
                                <a href='/termos' target="_blank" rel="noopener noreferrer" className="text-white mr-3">
                                    Termo e condições
                                </a>
                            </div>
                        </div>
                        <div className="box-rodape-logo">
                            <div className="d-flex justify-content-center align-items-center" >
                                <a href="/" ><img className="logo-rodape" src={logo_rodape} alt="fundo-imagem-home" /></a>
                            </div>
                            <div className="d-flex justify-content-center align-items-center" style={{ fontSize: '12px' }}>
                                <p>CNPJ: 23.524.979/0001-00</p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
            <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Termos e Condições</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Pertence à PENTALOBE pessoa jurídica de direito privado, Sediada em Blumenau, Santa Catarina. Oferece através de seu site, um serviço de compra e venda de aparelhos eletrônicos (“Aparelho”) usados, pelo qual os seus Usuários podem comprar e vender aparelhos, bem como acumular pontos para trocas no próprio site da Pentalobe.</p>
                    <p></p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Rodape;
